// Module
var code = "<span class=\"grow\"></span>\r\n<a href=\"http://badpanda.app\">&copy; 2020 Gourmet Petfood Kitchen Limited</a>\r\n<!--<span style=\"padding: 0 20px;\">|</span>-->\r\n\r\n<span class=\"grow\"></span>\r\n";
// Exports
module.exports = code;